module.exports = __webpack_public_path__ + "media/148.d04dd2bb.wav";